import type { ResetPasswordRequestOptions } from '@auth0/auth0-acul-react/types';
import {
  backToLogin,
  resetPassword,
  useScreen,
  useUntrustedData,
} from '@auth0/auth0-acul-react/reset-password-request';

import { executeSafely } from '@/utils/helpers/executeSafely';

export const useResetPasswordRequestManager = () => {
  const screen = useScreen();
  const { isCaptchaAvailable, captcha } = screen;

  const handleResetPasswordRequest = async (
    username: string,
    captchaValue?: string,
  ): Promise<void> => {
    const options: ResetPasswordRequestOptions = {
      username: username?.trim() || '',
    };

    if (screen.isCaptchaAvailable && captchaValue?.trim()) {
      options.captcha = captchaValue.trim();
    }

    executeSafely(
      `Reset password Request with options: ${JSON.stringify(options)}`,
      () => resetPassword(options),
    );
  };

  const handleBackToLogin = async (): Promise<void> => {
    executeSafely('Navigating back to login', () => backToLogin());
  };

  return {
    handleResetPasswordRequest,
    handleBackToLogin,
    inputfield: useUntrustedData().submittedFormData?.username || '',
    captcha,
    isCaptchaAvailable,
  };
};
